import type {
  AdminOrganizationMrrOverviewRow,
  AdminOrganizationMrrSetting,
  AdminOrganizationMrrSettingInput,
  DolfinRpc
} from '../../rpc'

export type {
  AdminOrganizationMrrOverviewRow,
  AdminOrganizationMrrSetting,
  AdminOrganizationMrrSettingInput
}
export const ADMIN_ORGANIZATION_MRR_CURRENCY = 'EUR' as const

export default class Organizations {
  private readonly rpcClient: DolfinRpc

  constructor(rpcClient: DolfinRpc) {
    this.rpcClient = rpcClient
  }

  async getAdminOrganizationMrrOverview(): Promise<AdminOrganizationMrrOverviewRow[]> {
    return this.rpcClient.getAdminOrganizationMrrOverview()
  }
  async getActiveUserCount(organizationId: number): Promise<number> {
    if (!Number.isInteger(organizationId) || organizationId <= 0) {
      throw new Error('organizationId must be a positive integer')
    }

    return this.rpcClient.getActiveOrganizationUserCount(organizationId)
  }

  async saveAdminOrganizationMrrSetting(
    params: AdminOrganizationMrrSettingInput
  ): Promise<AdminOrganizationMrrSetting> {
    if (!Number.isInteger(params.organizationId) || params.organizationId <= 0) {
      throw new Error('organizationId must be a positive integer')
    }

    if (typeof params.included !== 'boolean') {
      throw new Error('included must be a boolean')
    }

    if (!Number.isFinite(params.pricePerSeat) || params.pricePerSeat < 0) {
      throw new Error('pricePerSeat must be a non-negative number')
    }

    return this.rpcClient.saveAdminOrganizationMrrSetting(params)
  }
}
